import React from 'react';
import styled from 'styled-components';

const NUM_ARRAY = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;


const NumbersRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
`;

const NumberLabel = styled.div<{ show: boolean }>`
  width: 8px;
  text-align: center;
  opacity: ${(props) => (props.show ? 1 : 0)};
`;

const TrackWrapper = styled.div`
  position: relative;
  height: 8px;
  background: ${({ theme }) => theme.colors.gray['200']};
  border-radius: 40px;
`;

const FilledTrack = styled.div<{ width: number }>`
  position: absolute;
  width: ${(props) => props.width}%;
  height: 100%;
  background: ${({ theme }) => theme.colors.gray['800']};
  border-radius: 40px;
`;

const SliderThumb = styled.div<{ position: number }>`
  position: absolute;
  left: calc(${(props) => props.position}% - 8px);
  top: -4px;
  width: 16px;
  height: 16px;
  background: white;
  border: 1px solid ${({ theme }) => theme.colors.gray['100']};
  border-radius: 50%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.15s;

  &:hover {
    transform: scale(1.15);
  }
`;

const SliderInput = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
  margin: 0;

  &:disabled {
    cursor: not-allowed;
  }
`;

const TickMarksRow = styled.div`
  display: flex;
  justify-content: space-between;
  height: 8px;
`;

const TickMark = styled.div`
  width: 2px;
  height: 100%;
  background: ${({ theme }) => theme.colors.gray['100']};
  border-radius: 2px;
`;

type DeviceSliderProps = {
  value: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
};

const DeviceSlider: React.FC<DeviceSliderProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const percentage = (value / 9) * 100;

  return (
    <SliderContainer>
      <NumbersRow>
        {NUM_ARRAY.map((num) => (
          <NumberLabel key={num} show={num === value}>
            {num}
          </NumberLabel>
        ))}
      </NumbersRow>
      <TrackWrapper>
        <FilledTrack width={percentage} />
        <SliderThumb position={percentage} />
        <SliderInput
          type="range"
          min="0"
          max="9"
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
      </TrackWrapper>
      <TickMarksRow>
        {NUM_ARRAY.map((num) => (
          <TickMark key={num} />
        ))}
      </TickMarksRow>
    </SliderContainer>
  );
};

export default DeviceSlider;
